import apolloClient from '../../utils/apollo-client';
import { getUserProfile as query } from '../graphql/user';

export default async function getUser(isIgnoreCache) {
  const response = await apolloClient().then((client) =>
    client.query({
      query,
      fetchPolicy: isIgnoreCache ? 'network-only' : 'cache-first'
    })
  );
  return response.data.getUserProfile;
}
